<div class="fixed-width-modal">
    <div class="dialog-header d-flex justify-content-between align-items-center">
        <h2 mat-dialog-title class="mb-0">About eWarranty</h2>
    </div>

    <div mat-dialog-content>
        <p *ngIf="canStartClaim; else updatedMessage">
            PPP on eWarranty is live. Please submit all PPP claims including New, Used, Allied or Legacy plans through eWarranty. Anything started in the PPP system will be processed as normal.
        </p>
        <ng-template #updatedMessage>
            <p>
                PPP on eWarranty is live. Please submit all PPP claims including New, Used, Allied or Legacy plans through eWarranty.
            </p>
        </ng-template>
        <div class="text-center mt-2">
            <button type="button" mat-button color="primary" (click)="closeDialog()">Proceed to Claims in the PPP system</button>
        </div>
    </div>
</div>